import {
  Box,
  Heading,
  Text,
  Stack,
  Divider,
  useDisclosure,
  Flex,
  Icon,
} from "@chakra-ui/react";

import React from "react";
import { Button } from "ui";

import {
  MentorRequestModal,
  BOOKING_TYPE,
} from "../BookingRequestModal/MentorRequestModal";
import { Disclaimer } from "../../Disclaimer";
import { ReportRequestModal } from "../../feedback/report/ReportModal";
import { FaFlag } from "react-icons/fa";

interface IDetailsCars {
  mentorId: string;
  mentorName: string;
}

export const DetailsCard: React.FC<IDetailsCars> = ({
  mentorId,
  mentorName,
}) => {
  const { onOpen, onClose, isOpen } = useDisclosure();
  const {
    onOpen: onOpenReportModal,
    onClose: onCloseReportModal,
    isOpen: isOpenReportModal,
  } = useDisclosure();

  return (
    <>
      <Box pt={10}>
        <Box
          w={"full"}
          bg="white"
          boxShadow={"2xl"}
          rounded={"md"}
          overflow={"hidden"}
        >
          <Box py={1.5} backgroundColor="#0E1C72" borderRadius="6px 6px 0 0" />
          <Box p={8}>
            <Heading
              mb={5}
              color="primaryTextColor"
              fontSize={"2xl"}
              textAlign={"center"}
            >
              Mentor kontaktieren
            </Heading>

            <Text textAlign={"center"}>
              Hast du Fragen, möchtest einen Individualtermin oder den Mentor
              für einen Workshop buchen?
            </Text>

            <Stack justifyContent="center" mt={5}>
              <Divider mb={5} color="secundaryTextColor" />
              <Stack justifyContent="center" spacing={5}>
                <Button
                  label="Mentor kontaktieren"
                  type="solid"
                  onClick={onOpen}
                />
                <Disclaimer />
              </Stack>
            </Stack>
          </Box>
        </Box>
        <Flex
          mt={4}
          justifyContent={"center"}
          alignItems={"center"}
          cursor={"pointer"}
          onClick={onOpenReportModal}
        >
          <Icon as={FaFlag} color={"gray.600"} />
          <Text ml={4} color={"gray.600"} textDecor={"underline"}>
            Diesen Mentor melden
          </Text>
        </Flex>
      </Box>

      <MentorRequestModal
        subject="Mentoren Direktanfrage"
        buttonText="Kontaktanfrage senden"
        emailPreHeader="Wir haben eine neue Anfrage für dich"
        type={BOOKING_TYPE.MENTOR_DIRECT_BOOKING}
        onClose={onClose}
        isOpen={isOpen}
        mentorId={mentorId}
      />
      <ReportRequestModal
        mentorName={mentorName}
        mentorId={mentorId}
        isOpen={isOpenReportModal}
        onClose={onCloseReportModal}
      />
    </>
  );
};
